import { render, staticRenderFns } from "./GeneralCondition.vue?vue&type=template&id=68829496&scoped=true"
import script from "./GeneralCondition.vue?vue&type=script&lang=js"
export * from "./GeneralCondition.vue?vue&type=script&lang=js"
import style0 from "./Return.scss?vue&type=style&index=0&id=68829496&prod&scoped=true&lang=scss&external"
import style1 from "./GeneralCondition.vue?vue&type=style&index=1&id=68829496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68829496",
  null
  
)

export default component.exports